var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.12498 6.75H6.72748M4.12498 9.75H6.72748M9.37498 16.5H3.05998C2.18998 16.5 1.47748 15.8025 1.47748 14.9475V3.8175C1.47748 1.8525 2.93998 0.960002 4.73248 1.8375L8.06248 3.4725C8.78248 3.825 9.37498 4.7625 9.37498 5.5575V16.5ZM16.4775 11.295V14.13C16.4775 15.75 15.7275 16.5 14.1075 16.5H9.37498V7.815L9.72748 7.89L13.1025 8.6475L14.625 8.985C15.615 9.2025 16.425 9.7125 16.47 11.1525C16.4775 11.1975 16.4775 11.2425 16.4775 11.295V11.295Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1025 8.6475V11.0625C13.1025 11.9925 12.345 12.75 11.415 12.75C10.485 12.75 9.72748 11.9925 9.72748 11.0625V7.89L13.1025 8.6475ZM16.47 11.1525C16.4472 11.583 16.2604 11.9885 15.9479 12.2856C15.6355 12.5827 15.2211 12.7489 14.79 12.75C13.86 12.75 13.1025 11.9925 13.1025 11.0625V8.6475L14.625 8.985C15.615 9.2025 16.425 9.7125 16.47 11.1525Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.c78650c1c5ca3ea01620269ea0d9896b.svg";
export { ForwardRef as ReactComponent };